import React from 'react'

type BadgeProps = {
  icon?: React.ElementType
  label: string
  value?: number | string
  color?: string
  bg?: string
  border?: string
}

export const Badge = ({
  icon: Icon,
  label,
  value,
  color = '#0EA5E9',
  bg = 'rgba(14,165,233,.14)',
  border = '#f9fafaff'
}: BadgeProps) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 10px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
        background: bg,
        border: `1px solid ${border}`,
        color,
        userSelect: 'none',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        touchAction: 'manipulation'
      }}
    >
      {Icon && (
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0
          }}
        >
          <Icon size={14} />
        </span>
      )}

      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </span>

      {value !== undefined && (
        <span
          style={{
            marginLeft: 4,
            minWidth: 18,
            height: 18,
            borderRadius: 999,
            background: color,
            color: '#fff',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 10,
            fontWeight: 800,
            padding: '0 6px',
            flexShrink: 0
          }}
        >
          {value}
        </span>
      )}
    </div>
  )
}
